/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnInit, AfterViewInit} from "@angular/core";

import {Property} from "../../models/property";
import {PropertyType} from "../../models/property-type";
import {Rule} from "../../models/rule";
import {RuleCondition, Operator, Type} from "../../models/rule-condition";

import { ZoneInstance } from "../../models/zone-instance";
import { ZoneService } from "../../services/zone.service";
import { LocationInstance } from "../../models/location-instance";
import { LocationService } from "../../services/location.service";

declare var $: any;

const ID = "step3_addFilters";

@Component({
  selector: 'app-rule-editor-step-add-filters',
  templateUrl: './rule-editor-step-add-filters.component.html'
})
export class RuleEditorStepAddFiltersComponent implements OnInit, AfterViewInit {
  
    //Main DIV ID, referenced here so it can be used in the .html as well as the JQuery stuff internal to this component
    mId = ID;

    @Input()
    mRule: Rule;
  
    locations: LocationInstance[] = [];
    mSourceTypes = Type;
  
    constructor(
        private locationService: LocationService,
        private zoneService: ZoneService) {}
    
    ngOnInit(): void {
        this.loadLocationsAndZones();
    }
    
    ngAfterViewInit(): void {
        console.log("---afterINit: " + this.locations);
    }
    
    async loadLocationsAndZones(): Promise<void> {
        try {
            const locations: LocationInstance[] = await this.locationService.getAllLocationInstances();
            
            for (let location of locations) {
                const zones: ZoneInstance[] = await this.zoneService.getZonesByLocationId(location.id);
                location.zones = zones;
            }
            
            this.locations = locations;
        }
        catch (error) {
            console.log(error);
        }
    }
    
    setVisible(visible: boolean): void {
        visible? $("#" + this.mId).show() : $("#" + this.mId).hide();
    }

    onAddLocationFilter(): void {
        console.log(this.mRule);
        if (this.mRule != null) {
            this.mRule.locations = [];
            this.mRule.zones = [];
        }
    }

    onAddTimeFilter(): void {
        this.mRule.days = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
        this.mRule.startTime = "";
        this.mRule.endTime = "";
    }
    
    onAddTagFilter(): void {
        if (this.mRule != null) {
            const condition = new RuleCondition();
            condition.sourceType = Type.TAG;
//            condition.operator = Operator.EXISTS;
            
            if (this.mRule.conditions == null) {
                this.mRule.conditions = [ condition ];
            } 
            else {
                this.mRule.conditions.push(condition);
            }
        }
    }
    
    onAddFilter(type: Type): void {
        const condition = new RuleCondition();
//        condition.operator = Operator.EXISTS;
        condition.sourceType = type;
                
        if (this.mRule.conditions == null) {
            this.mRule.conditions = [ condition ];
        } 
        else {
            this.mRule.conditions.push(condition);
        }           
    }

}

